module.exports = __webpack_public_path__ + "img/solar-radiation.9cdc2916.svg";